import DocActivityInput from './DocActivityInput';

export default DocActivityInput;
